@if (visible$ | async) {
  <div class="template" [innerHTML]="template()"></div>
}
